module.exports = __webpack_public_path__ + "img/thumbnail_LarGibbon_m_leucistic.5a8a58c4.png";